class TriggerMobileSocialShare {
    constructor($mobileShare, $floor) {

        this.toggleShareStickyness = this.toggleShareStickyness.bind(this);
        this.floorTarget = document.querySelector($floor);
        this.$mobileShare = $mobileShare;

        console.log('floorTarget', this.floorTarget);

        if (!this.floorTarget) {
            this.$footerObserver = this.isFooterAppended($floor, this.toggleShareStickyness);
        } else {
            this.toggleShareStickyness('noObserver');
        }
    }

    toggleShareStickyness(hasObserver) {

        console.log('toggleShareStickyness', this.floorTarget);

        if (hasObserver != 'noObserver') {
            this.$footerObserver.disconnect();
        }
        let $floorLimit = this.floorTarget;

        window.addEventListener('scroll', () => {
            if ($floorLimit && this.isAnyPartOfElementInViewport($floorLimit)) {
                if (!this.$mobileShare.classList.contains('non-sticky')) {
                    this.$mobileShare.classList.add('non-sticky');
                }
            } else {
                if (this.$mobileShare.classList.contains('non-sticky')) {
                    this.$mobileShare.classList.remove('non-sticky');
                }
            }
        })
    }

    isAnyPartOfElementInViewport(el) {

        const rect = el.getBoundingClientRect();
        // DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
        const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
        const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

        // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
        const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
        const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

        return (vertInView && horInView);
    }

    // footer is injected dynamically need to know when is appended.
    // will use MutationObserver to find out
    isFooterAppended($footerStr, $triggerCallBack) {
        var targetNode = document.querySelector('body');
        // Options for the observer (which mutations to observe)
        var config = { attributes: true, childList: true, subtree: true };

        // Callback function to execute when mutations are observed
        var callback = function (mutationsList, observer) {
            for (var mutation of mutationsList) {
                if (mutation.type == 'childList') {
                    let $globalFooter = document.querySelector($footerStr);
                    if ($globalFooter) {
                        $triggerCallBack();
                    }
                }
            }
        };

        // Create an observer instance linked to the callback function
        var observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);

        // observer.disconnect();
        return observer;

    }
}